exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n[data-v-3c76cbcb]:export {\n  xrColorPrimary: #2362FB;\n}\n.section[data-v-3c76cbcb] {\n  margin: 15px 0;\n}\n", ""]);

// exports
